import React from "react";
import { Icon } from "@mui/material";

import styles from "../../../styles.module.css";

const NotSet: React.FC = () => (
  <div className={styles.notSet}>
    <Icon className={styles.notSetInfoIcon}>info</Icon>

    None Specified
  </div>
);

export default NotSet;
